import { useState } from 'react';

/**
 * Voting Power Tooltip Component
 * Shows detailed breakdown of voting power on hover
 */
export function VotingPowerTooltip({ votingPower, children }) {
  const [showTooltip, setShowTooltip] = useState(false);

  if (!votingPower || !votingPower.breakdown) {
    return children;
  }

  const breakdown = votingPower.breakdown;
  const totalWeight = votingPower.total_weight || 0;

  return (
    <div
      className="t24-voting-power-tooltip-wrapper"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {children}

      {showTooltip && (
        <div className="t24-voting-power-tooltip">
          <div className="tooltip-arrow"></div>

          <div className="tooltip-header">
            <span className="tooltip-icon">⚡</span>
            <span className="tooltip-title">Your Voting Power: {totalWeight.toFixed(1)}</span>
          </div>

          <div className="tooltip-breakdown">
            {breakdown.admin && (
              <div className="breakdown-item">
                <span className="breakdown-label">
                  <span className="breakdown-icon">👑</span>
                  Administrator
                </span>
                <span className="breakdown-value">{breakdown.admin.toFixed(1)}</span>
              </div>
            )}

            {breakdown.role && (
              <div className="breakdown-item">
                <span className="breakdown-label">
                  <span className="breakdown-icon">🎭</span>
                  {breakdown.role_type || 'Role'}
                  {breakdown.category && <span className="breakdown-category"> ({breakdown.category})</span>}
                </span>
                <span className="breakdown-value">{breakdown.role.toFixed(1)}</span>
              </div>
            )}

            {breakdown.base && (
              <div className="breakdown-item">
                <span className="breakdown-label">
                  <span className="breakdown-icon">👤</span>
                  Base Member
                </span>
                <span className="breakdown-value">{breakdown.base.toFixed(1)}</span>
              </div>
            )}

            {breakdown.type && !breakdown.role && !breakdown.admin && (
              <div className="breakdown-item">
                <span className="breakdown-label">
                  <span className="breakdown-icon">🌟</span>
                  {breakdown.type === 'community_member' ? 'Community Member' : breakdown.type}
                </span>
                <span className="breakdown-value">{totalWeight.toFixed(1)}</span>
              </div>
            )}
          </div>

          <div className="tooltip-footer">
            Higher voting power means your vote carries more weight in governance decisions.
          </div>
        </div>
      )}
    </div>
  );
}
